module.exports = __webpack_public_path__ + "static/media/alyson.cf21a949.jpg";